import { LandingPageComponent } from 'components/LandingPage/LandingPageComponent'
import { NextPage } from 'next'
import React from 'react'

interface Props {
  vcslug: string
}

const LandingPageIndex: NextPage<Props> = ({ vcslug }) => {
  return <LandingPageComponent vcslug={vcslug} />
}

LandingPageIndex.getInitialProps = (ctx) => {
  const vcslug = String(ctx.query.vcslug).toLowerCase()

  return { vcslug }
}

export default LandingPageIndex
